module.exports = __webpack_public_path__ + "img/not_rating.7d7103ae.svg";